/*
 * custom-script-bcb.js — Bcb v1.0
 * Tous les scripts ajoutés au thème Kale fait maison, au même endroit.
 * Chargé dans layout/theme.liquid, juste après global.js (defer).
 *
 * 1. Kit kraft / kit réutilisable (consigne non taxable)
 * 2. Fiche produit : total dynamique dans le bouton « Ajouter au panier »
 */

/* Textes traduisibles : fichiers de langue du thème (section « bcb »), via snippets/bcb-textes.liquid */
const bcbTexte = (() => {
  let textes = null;
  return (cle, defaut) => {
    if (!textes) {
      try {
        textes = JSON.parse(document.getElementById('bcb-textes').textContent);
      } catch (erreur) {
        textes = {};
      }
    }
    const valeur = textes[cle];
    if (!valeur) return defaut;
    // Shopify encode certains caractères (apostrophes…) dans les textes traduits : on les décode
    const decodeur = document.createElement('textarea');
    decodeur.innerHTML = valeur;
    return decodeur.value;
  };
})();

/* =========================================================================
   1. Kit kraft / kit réutilisable (consigne non taxable)
   ========================================================================= */
(() => {
  // Produit technique de la consigne (non répertorié, non taxable), reconnu par son handle
  const HANDLE_CONSIGNE = 'consigne-kit-reutilisable';
  const estConsigne = (ligne) => ligne.handle === HANDLE_CONSIGNE;

  const racine = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  const enTetes = { 'Content-Type': 'application/json', Accept: 'application/json' };

  const panierPost = (route, corps) =>
    fetch(`${racine}${route}`, { method: 'POST', headers: enTetes, body: JSON.stringify(corps) }).then((reponse) =>
      reponse.json().then((donnees) => {
        if (!reponse.ok || donnees.status) throw new Error(donnees.description || donnees.message || 'Erreur panier');
        return donnees;
      })
    );

  const lirePanier = () => fetch(`${racine}cart.js`, { headers: { Accept: 'application/json' } }).then((r) => r.json());

  /* ---------- 1. Choix du kit ---------- */

  if (!customElements.get('kit-consigne')) {
    customElements.define(
      'kit-consigne',
      class KitConsigne extends HTMLElement {
        connectedCallback() {
          if (this.pret) return;
          this.form = document.getElementById(this.dataset.form);
          if (!this.form) return;
          this.pret = true;

          try {
            this.correspondances = JSON.parse(this.querySelector('[data-kit-map]').textContent || '{}');
          } catch (erreur) {
            this.correspondances = {};
          }
          this.choixReutilisable = this.querySelector('[data-kit-reutilisable]');
          this.champContenant = this.querySelector('[data-kit-contenant]');
          this.champRef = this.querySelector('[data-kit-ref]');
          this.champConsigne = this.querySelector('[data-kit-consigne]');

          this.querySelectorAll('input[type="radio"]').forEach((radio) =>
            radio.addEventListener('change', () => this.mettreAJour())
          );
          const champVariante = this.form.querySelector('[name="id"]');
          if (champVariante) champVariante.addEventListener('change', () => this.mettreAJour());
          this.mettreAJour();
        }

        get idVariante() {
          const champ = this.form.querySelector('[name="id"]');
          return champ ? String(champ.value) : '';
        }

        get consigne() {
          return this.correspondances[this.idVariante] || null;
        }

        get reutilisable() {
          return Boolean(this.consigne && this.choixReutilisable && this.choixReutilisable.checked);
        }

        mettreAJour() {
          const consigne = this.consigne;
          const offert = Boolean(consigne);
          this.choixReutilisable.disabled = !offert;
          if (!offert && this.choixReutilisable.checked) {
            this.querySelector('input[value="kraft"]').checked = true;
          }
          this.querySelectorAll('[data-kit-prix]').forEach((element) => {
            element.textContent = offert ? consigne.prix : '';
          });

          const reutilisable = this.reutilisable;
          this.champContenant.value = reutilisable
            ? bcbTexte('kitReutilisable', 'Kit réutilisable')
            : bcbTexte('kitKraft', 'Kit kraft');
          this.champRef.disabled = !reutilisable;
          this.champConsigne.disabled = !reutilisable;
          this.champRef.value = reutilisable ? this.idVariante : '';
          this.champConsigne.value = reutilisable ? String(consigne.id) : '';
        }
      }
    );
  }

  /* ---------- Info-bulle « i » de la consigne ---------- */

  // Un clic sur le « i » ouvre l'info-bulle sans sélectionner le kit
  const basculerInfo = (info, ouvrir) => {
    document.querySelectorAll('.kale-info[aria-expanded="true"]').forEach((autre) => {
      if (autre !== info) autre.setAttribute('aria-expanded', 'false');
    });
    if (!info) return;
    const etat = typeof ouvrir === 'boolean' ? ouvrir : info.getAttribute('aria-expanded') !== 'true';
    info.setAttribute('aria-expanded', String(etat));
  };

  document.addEventListener(
    'click',
    (evenement) => {
      const info = evenement.target.closest && evenement.target.closest('.kale-info');
      if (info) {
        evenement.preventDefault();
        evenement.stopPropagation();
        basculerInfo(info);
        return;
      }
      basculerInfo(null);
    },
    true
  );

  document.addEventListener('keydown', (evenement) => {
    const info = evenement.target.closest && evenement.target.closest('.kale-info');
    if (evenement.key === 'Escape') basculerInfo(null);
    if (info && (evenement.key === 'Enter' || evenement.key === ' ')) {
      evenement.preventDefault();
      basculerInfo(info);
    }
  });

  /* ---------- 2. Ajout au panier : la consigne d'abord, puis le repas ---------- */

  document.addEventListener(
    'submit',
    (evenement) => {
      const form = evenement.target;
      if (!(form instanceof HTMLFormElement)) return;
      const idForm = form.getAttribute('id');
      const kit = idForm && document.querySelector(`kit-consigne[data-form="${CSS.escape(idForm)}"]`);
      if (!kit || !kit.reutilisable) return;

      if (form.dataset.kitConsigneAjoutee === '1') {
        delete form.dataset.kitConsigneAjoutee;
        setTimeout(reconcilier, 2500);
        return;
      }

      evenement.preventDefault();
      evenement.stopImmediatePropagation();

      const productForm = form.closest('product-form');
      const bouton = form.querySelector('[type="submit"]');
      if (bouton && bouton.getAttribute('aria-disabled') === 'true') return;
      if (bouton) bouton.classList.add('loading');

      const quantite = parseInt(new FormData(form).get('quantity'), 10) || 1;
      const consigne = kit.consigne;

      panierPost('cart/add.js', {
        items: [
          {
            id: consigne.id,
            quantity: quantite,
            properties: { _kit_ref: kit.idVariante, [bcbTexte('pour', 'Pour')]: kit.dataset.pour },
          },
        ],
      })
        .then(() => {
          if (bouton) bouton.classList.remove('loading');
          form.dataset.kitConsigneAjoutee = '1';
          if (form.requestSubmit) {
            form.requestSubmit();
          } else {
            form.dispatchEvent(new Event('submit', { bubbles: true, cancelable: true }));
          }
        })
        .catch((erreur) => {
          console.error(erreur);
          if (bouton) bouton.classList.remove('loading');
          const message = bcbTexte('erreurAjout', "La consigne n'a pas pu être ajoutée. Veuillez réessayer.");
          if (productForm && productForm.handleErrorMessage) productForm.handleErrorMessage(message);
        });
    },
    true
  );

  /* ---------- 3. Réconciliation du panier ---------- */

  let enCours = null;
  let aRefaire = false;

  function reconcilier() {
    if (enCours) {
      aRefaire = true;
      return enCours;
    }
    enCours = executerReconciliation()
      .catch((erreur) => console.error(erreur))
      .finally(() => {
        enCours = null;
        if (aRefaire) {
          aRefaire = false;
          reconcilier();
        }
      });
    return enCours;
  }

  async function executerReconciliation() {
    const panier = await lirePanier();
    const attendu = {};

    panier.items.forEach((ligne) => {
      if (estConsigne(ligne)) return;
      const proprietes = ligne.properties || {};
      if (!proprietes._kit_ref || !proprietes._kit_consigne) return;
      const ref = String(proprietes._kit_ref);
      if (!attendu[ref]) {
        attendu[ref] = { id: Number(proprietes._kit_consigne), quantite: 0, pour: ligne.product_title };
      }
      attendu[ref].quantite += ligne.quantity;
    });

    const misesAJour = {};
    const trouvees = {};
    panier.items.forEach((ligne) => {
      if (!estConsigne(ligne)) return;
      const ref = String((ligne.properties || {})._kit_ref || '');
      const cible = attendu[ref];
      if (!cible || trouvees[ref] || ligne.variant_id !== cible.id) {
        misesAJour[ligne.key] = 0;
        return;
      }
      trouvees[ref] = true;
      if (ligne.quantity !== cible.quantite) misesAJour[ligne.key] = cible.quantite;
    });

    const ajouts = Object.keys(attendu)
      .filter((ref) => !trouvees[ref])
      .map((ref) => ({
        id: attendu[ref].id,
        quantity: attendu[ref].quantite,
        properties: { _kit_ref: ref, [bcbTexte('pour', 'Pour')]: attendu[ref].pour },
      }));

    if (!Object.keys(misesAJour).length && !ajouts.length) return;

    bloquerPaiement(true);
    try {
      if (Object.keys(misesAJour).length) await panierPost('cart/update.js', { updates: misesAJour });
      if (ajouts.length) await panierPost('cart/add.js', { items: ajouts });
      await rafraichirAffichage();
    } finally {
      bloquerPaiement(false);
    }
  }

  function bloquerPaiement(bloque) {
    document.querySelectorAll('#checkout, [name="checkout"]').forEach((bouton) => {
      bouton.toggleAttribute('disabled', bloque);
    });
  }

  async function rafraichirAffichage() {
    const cartItems = document.querySelector('cart-items');
    const sections =
      cartItems && cartItems.getSectionsToRender
        ? cartItems.getSectionsToRender()
        : [{ id: 'cart-icon-bubble', section: 'cart-icon-bubble', selector: '.shopify-section' }];
    const ids = [...new Set(sections.map((section) => section.section))];

    const [rendus, panier] = await Promise.all([
      fetch(`${window.location.pathname}?sections=${ids.join(',')}`).then((r) => r.json()),
      lirePanier(),
    ]);

    sections.forEach((section) => {
      const html = rendus[section.section];
      const conteneur = document.getElementById(section.id);
      if (!html || !conteneur) return;
      const source = new DOMParser().parseFromString(html, 'text/html').querySelector(section.selector);
      if (!source) return;
      (conteneur.querySelector(section.selector) || conteneur).innerHTML = source.innerHTML;
    });

    const vide = panier.item_count === 0;
    if (cartItems) cartItems.classList.toggle('is-empty', vide);
    const pied = document.getElementById('main-cart-footer');
    if (pied) pied.classList.toggle('is-empty', vide);
  }

  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
    subscribe(PUB_SUB_EVENTS.cartUpdate, () => reconcilier());
  }

  const surPagePanier = () => {
    if (document.querySelector('cart-items')) reconcilier();
  };
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', surPagePanier);
  } else {
    surPagePanier();
  }
  window.addEventListener('pageshow', (evenement) => {
    if (evenement.persisted) surPagePanier();
  });
})();

/* =========================================================================
   2. Fiche produit : total dynamique dans le bouton « Ajouter au panier »
   ========================================================================= */
(() => {
  if (customElements.get('kale-prix')) return;

  function formaterArgent(cents, format) {
    const modele = /\{\{\s*(\w+)\s*\}\}/;
    const nombre = (valeur, decimales, milliers, separateur) => {
      const fixe = (valeur / 100).toFixed(decimales);
      const [entier, fraction] = fixe.split('.');
      const avecMilliers = entier.replace(/\B(?=(\d{3})+(?!\d))/g, milliers);
      return fraction ? avecMilliers + separateur + fraction : avecMilliers;
    };
    const correspondance = (format || '${{amount}}').match(modele);
    if (!correspondance) return (cents / 100).toFixed(2);
    let valeur;
    switch (correspondance[1]) {
      case 'amount_no_decimals':
        valeur = nombre(cents, 0, ',', '.');
        break;
      case 'amount_with_comma_separator':
        valeur = nombre(cents, 2, '.', ',');
        break;
      case 'amount_no_decimals_with_comma_separator':
        valeur = nombre(cents, 0, '.', ',');
        break;
      case 'amount_with_space_separator':
        valeur = nombre(cents, 2, ' ', ',');
        break;
      case 'amount_with_apostrophe_separator':
        valeur = nombre(cents, 2, "'", '.');
        break;
      default:
        valeur = nombre(cents, 2, ',', '.');
    }
    return format.replace(modele, valeur);
  }

  customElements.define(
    'kale-prix',
    class KalePrix extends HTMLElement {
      connectedCallback() {
        if (this.pret) return;
        this.form = document.getElementById(this.dataset.form);
        if (!this.form) return;
        this.bouton = this.form.querySelector('[name="add"]');
        if (!this.bouton) return;
        this.pret = true;

        try {
          this.donnees = JSON.parse(this.querySelector('script[type="application/json"]').textContent);
        } catch (erreur) {
          return;
        }

        const conteneur = this.closest('.product__info-container');

        // Numérotation des étapes : Format, Servi avec, Contenant, Quantité (selon ce que le produit propose).
        // Une seule étape (produit simple, quantité seulement) : pas de numéro, un « 1 » seul n'aurait pas de sens.
        if (conteneur) {
          const titres = conteneur.querySelectorAll(
            'variant-radios legend.form__label, kit-consigne legend.form__label, .product-form__quantity .quantity__label'
          );
          if (titres.length > 1) {
            titres.forEach((titre, index) => titre.setAttribute('data-etape', index + 1));
          }
        }

        // La mention des frais d'expédition passe sous le bouton « Ajouter au panier »
        const mention = conteneur && conteneur.querySelector('.product__tax:not(.kale-mention-deplacee)');
        const blocBouton = this.form.closest('product-form');
        if (mention && blocBouton) {
          mention.classList.add('kale-mention-deplacee');
          blocBouton.after(mention);
        }

        // Icône de panier du thème devant le texte du bouton (le texte reste le premier <span>, que le thème réécrit)
        const libelleBouton = this.bouton.querySelector(':scope > span');
        const modeleIcone = this.querySelector('template[data-kale-icone-panier]');
        if (libelleBouton && modeleIcone && !this.bouton.querySelector('.kale-icone-panier')) {
          const icone = modeleIcone.content.querySelector('svg');
          if (icone) {
            const copie = icone.cloneNode(true);
            copie.classList.add('kale-icone-panier');
            libelleBouton.before(copie);
          }
        }

        this.affichage = document.createElement('span');
        this.affichage.className = 'kale-prix-bouton';
        const libelle = this.bouton.querySelector(':scope > span');
        if (libelle) libelle.after(this.affichage);
        else this.bouton.prepend(this.affichage);

        this.surChangement = (evenement) => {
          const cible = evenement.target;
          if (!cible || !cible.getAttribute) return;
          if (cible.getAttribute('form') === this.dataset.form || this.form.contains(cible)) this.mettreAJour();
        };
        document.addEventListener('change', this.surChangement);
        document.addEventListener('input', this.surChangement);

        // Le thème désactive le bouton pendant le chargement d'une variante : on recalcule à la réactivation
        this.observateur = new MutationObserver(() => this.mettreAJour());
        this.observateur.observe(this.bouton, { attributes: true, attributeFilter: ['disabled'] });

        // Le thème réécrit le prix principal à chaque changement de variante : on réapplique la consigne
        this.blocPrix = conteneur && conteneur.querySelector('[id^="price-"][role="status"]');
        if (this.blocPrix) {
          this.observateurPrix = new MutationObserver(() => this.mettreAJourPrixPrincipal());
          this.observateurPrix.observe(this.blocPrix, { childList: true, subtree: true, characterData: true });
        }
        this.mettreAJour();
      }

      disconnectedCallback() {
        if (this.observateur) this.observateur.disconnect();
        if (this.observateurPrix) this.observateurPrix.disconnect();
        if (this.surChangement) {
          document.removeEventListener('change', this.surChangement);
          document.removeEventListener('input', this.surChangement);
        }
      }

      // Prix sous le titre : prix du repas + consigne si le kit réutilisable est choisi
      mettreAJourPrixPrincipal() {
        if (!this.blocPrix) return;
        const kit = document.querySelector(`kit-consigne[data-form="${CSS.escape(this.dataset.form)}"]`);
        if (!kit || !kit.pret) return;
        const champVariante = this.form.querySelector('[name="id"]');
        const prix = champVariante ? this.donnees.variantes[String(champVariante.value)] : undefined;
        if (typeof prix !== 'number') return;

        const consigne = kit.reutilisable && kit.consigne ? Number(kit.consigne.cents) || 0 : 0;
        const formatPrix = this.donnees.formatPrix || this.donnees.format;
        const texte = formaterArgent(prix + consigne, formatPrix);
        this.blocPrix
          .querySelectorAll('.price__regular .price-item--regular, .price__sale .price-item--sale')
          .forEach((element) => {
            if (element.textContent.trim() !== texte) element.textContent = texte;
          });

        const ligne = this.blocPrix.querySelector('.price');
        if (!ligne) return;
        let mention = ligne.querySelector('.kale-prix-consigne');
        const texteMention = consigne
          ? bcbTexte('dontConsigne', 'dont [montant] de consigne (non taxable)').replace(
              '[montant]',
              formaterArgent(consigne, this.donnees.format)
            )
          : bcbTexte('kraftInclus', 'Kit kraft inclus');
        if (!mention && texteMention) {
          mention = document.createElement('span');
          mention.className = 'kale-prix-consigne';
          ligne.append(mention);
        }
        if (mention && mention.textContent !== texteMention) mention.textContent = texteMention;
      }

      mettreAJour() {
        const champVariante = this.form.querySelector('[name="id"]');
        const prix = champVariante ? this.donnees.variantes[String(champVariante.value)] : undefined;
        const champQuantite = document.querySelector(`input[name="quantity"][form="${CSS.escape(this.dataset.form)}"]`);
        const quantite = Math.max(1, parseInt(champQuantite && champQuantite.value, 10) || 1);

        const kit = document.querySelector(`kit-consigne[data-form="${CSS.escape(this.dataset.form)}"]`);
        const consigne = kit && kit.reutilisable && kit.consigne ? Number(kit.consigne.cents) || 0 : 0;

        this.mettreAJourPrixPrincipal();
        if (typeof prix !== 'number' || this.bouton.disabled) {
          this.affichage.textContent = '';
          return;
        }
        this.affichage.textContent = formaterArgent((prix + consigne) * quantite, this.donnees.format);
      }
    }
  );

  // Le kit change après le clic : on recalcule aussi quand il se met à jour
  document.addEventListener('click', (evenement) => {
    const kit = evenement.target.closest && evenement.target.closest('kit-consigne');
    if (!kit) return;
    setTimeout(() => {
      const prix = document.querySelector(`kale-prix[data-form="${CSS.escape(kit.dataset.form)}"]`);
      if (prix && prix.mettreAJour) prix.mettreAJour();
    });
  });
})();
